export const API_URL = process.env.API_URL;
export const INFO_PLANT_API_URL = process.env.INFO_PLANT_API_URL;
export const LOGGING_ENABLED = process.env.LOGGING_ENABLED;
export const SENTRY_ENABLED = process.env.SENTRY_ENABLED;
export const SENTRY_DSN_URL = process.env.SENTRY_DSN_URL;

export const BACKOFFICE_LOGIN_USER_UUID = process.env.BACKOFFICE_LOGIN_USER_UUID;
export const FRONTEND_LOGIN_USER_EMAIL = process.env.FRONTEND_LOGIN_USER_EMAIL;
export const FRONTEND_LOGIN_USER_PASSWORD = process.env.FRONTEND_LOGIN_USER_PASSWORD;
export const AUTOCREATED_INFOPLANT_USER_PASSWORD = "&OO#FU8DE0m2";

export const VIRTUAL_TOUR_CONTACT_EMAIL = process.env.VIRTUAL_TOUR_CONTACT_EMAIL;
export const VIRTUAL_TOUR_FAQ_URL = process.env.VIRTUAL_TOUR_FAQ_URL;

export const USER_ENDPOINT = "users/";
export const LOGIN_ENDPOINT = "auth/login";
export const CHANGE_PASSWORD_ENDPOINT = "/password";
export const ME_ENDPOINT = "me";
export const INFO_PLANT_USER_ENDPOINT = "getUser.php";
export const INFO_PLANT_CODE = "bWVkaWFob3VzZQ==";

// responsive properties
export const DIM_BREAKPOINT_DESKTOP_WIDTH = 1440;

// form time step
export const INPUT_TIME_STEP = 60; // 60 = 1 minute

// table list items per page
export const TABLELIST_ITEMS_PER_PAGE = 15;

// forms
export const FORM_TYPE_TEXT = 1;
export const FORM_TYPE_INT = 2;
export const FORM_TYPE_DATE = 3;
export const FORM_TYPE_TIME = 4;
export const FORM_TYPE_DATETIME = 5;
export const FORM_TYPE_SELECT = 6;
export const FORM_TYPE_SELECT_2 = 7;
export const FORM_TYPE_EMAIL = 8;
export const FORM_TYPE_PASSWORD = 9;
export const FORM_TYPE_TEXTAREA = 10;
export const FORM_TYPE_INT_POSITIVE = 11;
export const FORM_TYPE_PHONE = 12;
export const FORM_TYPE_FILE = 13;
export const FORM_TYPE_MULTISELECT = 14;
export const FORM_TYPE_CHECKBOX = 15;

// forms width
export const FORM_WIDTH_COL_2 = 2;
export const FORM_WIDTH_COL_3 = 3;
export const FORM_WIDTH_COL_4 = 4;
export const FORM_WIDTH_COL_6 = 6;
export const FORM_WIDTH_COL_8 = 8;
export const FORM_WIDTH_COL_9 = 9;
export const FORM_WIDTH_COL_10 = 10;
export const FORM_WIDTH_COL_12 = 12;

// forms offset
export const FORM_WIDTH_OFFSET_COL_0 = 0;
export const FORM_WIDTH_OFFSET_COL_2 = 2;
export const FORM_WIDTH_OFFSET_COL_3 = 3;
export const FORM_WIDTH_OFFSET_COL_4 = 4;
export const FORM_WIDTH_OFFSET_COL_6 = 6;
export const FORM_WIDTH_OFFSET_COL_8 = 8;
export const FORM_WIDTH_OFFSET_COL_10 = 10;

// search clauses

export const EDIT_MODE = 1;
export const ADD_MODE = 2;
export const DETAIL_MODE = 3;

export const SPHERE_BTN_BLUE = "#0052CC 0% 0%";
export const SPHERE_BTN_GREEN = "transparent linear-gradient(180deg, #14814F 0%, #0C5333 100%) 0% 0%";
export const SPHERE_BTN_YELLOW = "transparent linear-gradient(180deg, #FFBB20 0%, #926116 100%) 0% 0%";
export const SPHERE_BTN_GRAY = "transparent linear-gradient(180deg, #444444 0%, #313131 100%) 0% 0%";
export const SPHERE_BTN_RED = "#CE2E0D 0% 0%";

export const SPHERE_ACTION_CHANGE_MARKER = "change_marker";
export const SPHERE_ACTION_PLANT = "plant";
export const SPHERE_ACTION_PROMO = "promo";
export const SPHERE_ACTION_ARROWS = "arrows";
export const SPHERE_ACTION_REMOVE = "remove";
export const SPHERE_ACTION_SHORTCUT = "shortcut";
export const SPHERE_ACTION_CORRECT = "correct";
export const SPHERE_ACTION_PRODUCT_LINK = "product_link";

export const LOG_EVENT_PRODUCT = 1;
export const LOG_EVENT_PROMOTION = 2;
export const LOG_EVENT_PHOTOSPHERE = 3;

// search debounce time

export const SEARCH_LETTER_TRESHOLD = 2;
export const SEARCH_DEBOUNCE_TIME = 400;

// Language code

export const LANG_CODE_IT = "it";
export const LANG_CODE_EN = "en";
export const LANG_CODE_FR = "fr";

export const PRODUCTS_LANG_CODE_IT = "ITA";
export const PRODUCTS_LANG_CODE_EN = "ING";
export const PRODUCTS_LANG_CODE_FR = "FRA";

export const PHOTOSPHERE_IMAGE_TAG = "PHOTOSPHERE_IMAGE";
export const PROMOTION_IMAGE_TAG = "PROMOTION_IMAGE";